export default "__VITE_ASSET__00280380__"